import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Textarea } from '@components/common';
import { SendButton } from '@components/shared/AgentMessage';
import { useStudyBuilder } from '@components/shared/StudyBuilderProvider';
import { PlusSVG } from '@components/svgs';

const SAMPLE_PROMPTS = [
  'Test if new users can complete onboarding without confusion',
  'Evaluate whether users want and would use a shared dashboard',
  "Explore why new signups aren't activating their accounts.",
  'Understand if users trust our new AI assistant concept.',
  'Check if users understand our new pricing page design.'
];

export const AgentPrompt = () => {
  const { isLoading, sendMessage } = useStudyBuilder();
  const [inputValue, setInputValue] = useState('');
  const navigate = useNavigate();

  // Navigate to builder after sending a message
  const handleSendMessage = () => {
    const value = inputValue.trim();
    if (value) {
      sendMessage(value);
      setInputValue('');
      navigate('/studies/intake');
    }
  };

  const handleCopyPrompt = (prompt: string) => {
    setInputValue((prev) => (prev ? `${prev}\n${prompt}` : prompt));
  };

  return (
    <div className='flex gap-0'>
      <div className='relative flex w-1/2 flex-col space-y-1 rounded-lg border bg-white p-2'>
        <Textarea
          autoFocus
          value={inputValue}
          onChange={setInputValue}
          name='message'
          placeholder='Ask Great Question…'
          className='w-full flex-1 border-0 text-sm focus:ring-0'
          minRows={2}
          maxRows={4}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSendMessage();
            }
          }}
        />
        <div className='flex justify-end'>
          <SendButton onClick={handleSendMessage} disabled={isLoading || !inputValue.trim()} />
        </div>
      </div>

      <div className='w-1/2 pl-4'>
        <h3 className='mb-3 text-sm font-medium text-gray-700'>Sample prompts</h3>
        <div className='space-y-0'>
          {SAMPLE_PROMPTS.map((prompt, index) => (
            <button
              key={index}
              onClick={() => handleCopyPrompt(prompt)}
              className='group flex w-full items-center justify-between border-b border-gray-200 py-2 text-left last:border-b-0'
            >
              <div className='flex flex-1 items-center justify-between rounded-lg px-2 py-1 transition-colors group-hover:bg-gray-100'>
                <span className='flex-1 pr-2 text-sm text-gray-600 group-hover:text-indigo-600'>{prompt}</span>
                <PlusSVG className='h-4 w-4 text-gray-400 transition-colors group-hover:text-gray-600' />
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
